<template>
  <TextField
    :id="`tender-id-${planType}-${index}`"
    :name="fieldName"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.tenders.tenderID')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.tenders.tenderIDPlaceholder')"
    :required="!isDisabled"
    :disabled="isDisabled"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  planType: {
    type: String,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

// Set localization
const { t } = useI18n();
</script>
